module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAAAoBAMAAABJMqgvAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAkUExUReHh4ZGRkbCwsKurq6KiopeXl5SUlK2traenp6WlpZqamp6enjEzs3IAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAB1SURBVFjD3ddBEcAgEATBtYAFLMQCFmIBC1jAQixgAXMpCg07j20BzIMiuVMFKCcyAHoATGQC9AHUAExkH7K5x6/DF7nHL4BeABPpACZSAGDE907oSM6duCM5jzHnA8n9tNyRDQgaiZAJEpmFc1YHZNOKWUx/Kngouyzv5aoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/split-panel/divide-vertical.png
// module id = 769
// module chunks = 0